// extracted by mini-css-extract-plugin
module.exports = {"carruselContainer":"Carrusel_carruselContainer__2TT5W","carruselViewport":"Carrusel_carruselViewport__3jK17"};